export default "__VITE_ASSET__By7FMp4O__"